import { useQuery, type UseQueryResult } from '@tanstack/react-query';

export type CommunicationPreferencesFormValue = {
    isWaitingListMember: boolean;
    renewalDeliveryMethod: string | null;
    newsletterEmails: boolean | null;
    eventEmails: boolean | null;
    annualReportEmails: boolean | null;
    functionDiningEmails: boolean | null;
    researchEmails: boolean | null;
    mccPlusEmails: boolean | null;
    waitingListEmails: boolean | null;
    isUnsubscribed: boolean | null;
};

type CommunicationPreferencesValueApiReturn = {
    isSuccess: boolean;
    data: CommunicationPreferencesFormValue;
    errorMessages: string | null;
    exception: string | null;
}

const useCommunicationPreferencesValue = (): UseQueryResult<CommunicationPreferencesValueApiReturn> => {
    const endpoint = '/api/Members/current/communicationpreferences';

    const communicationPreferencesValueQuery = useQuery({
        queryKey: ['communicationPreferencesValue'],
        queryFn: async() => {
            const response = await fetch(endpoint);
            if (!response.ok) {
                throw new Error('Failed to fetch communication preferences value');
            }
            return response.json();
        },
        staleTime: Number.POSITIVE_INFINITY,
    });

    return communicationPreferencesValueQuery;
};

export default useCommunicationPreferencesValue;
